<app-loading *ngIf="!isLoaded"></app-loading>

<div *ngIf="isAuthorized && isLoaded">
    <div class="action-menu">
        
    </div>

    <div style="margin-bottom: 100px;">

        <div class="row">
            <div class="col-sm-12">

                <div class="pull-left" style="margin-top:20px;">
                    Reports
                </div>

                <div class="action-menu">
                    <button class="btn btn-default btn-lg ng-scope" type="button" (click)="go_back()"> 
                        <div class="inline">< Back </div>
                    </button>
                </div>
            </div>
        </div>

        <app-reports-pars></app-reports-pars>
        <app-reports-pars-individual></app-reports-pars-individual>
    </div>
</div>